import React from "react";
export default function PDFInvoiceViewer({ src }) {
  return <iframe title="PDF Viewer" src={src} height="1000px" width="100%"></iframe>;
}
